import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _DocumentFactory, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { DocumentStorageEditor } from "../../../../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _PaymentTurn } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../theme/Component/Modal";
import useModal, { MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { Alert } from "../../../../../theme/Component/Alert";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface responseProps {
    Year: number;
    CodeTurn: number;
}

export const AOP001 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const [ublList, setUbList] = useState<any>([]);
    const [response, setResponse] = useState<Partial<responseProps>>({
        Year: _single.getCurrenYear(),
    })

    const { instance, bean } = useDataBean(_PaymentTurn)
    const _doc = useDataBean(_DocumentFactory);

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const data = configProcedure?._pocessData?.Props;
            setProps(data)            

            if (typeof (data.Causaciones) === "string" && data.Causaciones != "") {
                setUbList(JSON.parse(data.Causaciones))
            }

        }
        
    }, [configProcedure?._pocessData])

    const onExportMap = async () => {
        if (!ublList || ublList.length === 0) {
            toast.error("No hay causaciones para enturnar");
            return;
        }

        const procedure = configProcedure._procedure;

        try {
            for (const element of ublList) {
                await instance.addPaymentAccountToPaymentTurn(
                    response.Year,
                    element.IDDocument,
                    element.DocumentDate,
                    response.CodeTurn,
                    procedure.IDProcedureImp,
                    procedure.Since,
                    _single.getAccountID()
                ).then(resp => {
                    console.log("✅ Enturnado:", element.IDDocument, resp);
                }).catch(err => {
                    toast.error(`Error al enturnar documento ${element?.Mnemonic} - ${element?.Consecutive}`);
                    throw err;
                });
            }

            const resumen = ublList.map((causa, index) => {
                return `${index + 1}. ${causa?.Mnemonic ?? ""} - ${causa?.Consecutive ?? ""} - ${causa?.DocumentDate ?? ""}`;
            }).join("; ");

            if (configProcedure?._pushInfo) {
                configProcedure._pushInfo(
                    _single.jsonToBootstrapTable({
                        "Vigencia": response.Year,
                        "Turno": response.CodeTurn,
                        "Documentos Enturnados": resumen,
                    })
                );
            }

            if (configProcedure?._pushProps) {
                configProcedure._pushProps({
                    CodeTurn: response.CodeTurn,
                    VigencyTurn: response.Year
                });
            }

            if (configProcedure?._exportMap) {
                configProcedure._exportMap(response);
            }

            toast.success("Todos los documentos fueron enturnados correctamente");

        } catch (error) {
            console.error("⛔ Se detuvo el proceso por error:", error);
        }
    };




    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            onExportMap();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Year"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (response[field] === null || response[field] === undefined || response[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const modalDoc = useModal("Documento", MODAL_XL);

    const [documentos, setDocuementos] = useState<any>([]);

    const getPdfAccountantDocument = (id: number, mnemonic: string, date: any) => {
        _doc.instance.getPdfAccountantDocument(id, mnemonic, date, _single.getAccountID()).then(
            (resp: any) => {
                modalDoc.open();
                setDocuementos(resp.DocumentURL);
            }
        ).catch(err => toast.error(err));
    }

    return (
        <div className="row">
            {props.Causaciones ? (
                <div className="col-md-12">
                    <strong>Causaciones Seleccionadas</strong>

                    {ublList.length > 0 ? (
                        <>
                            {/* <PrintJson json={props} />
                            <PrintJson json={ublList} /> */}
                            {ublList.map((data, index) => (
                                <div key={index} className="pointer" onClick={() => { getPdfAccountantDocument(data.IDDocument, data.Mnemonic, data.DocumentDate) }} >
                                    {data?.Mnemonic} - {data?.Consecutive}
                                </div>
                            ))}
                        </>
                    ) : (
                        <div>No hay causaciones cargadas</div>
                    )}
                </div>
            ) : (
                <Alert children="No se seleccionó ninguna Causación" clase="info" />
            )}

            <div className="col-md-6">
                <label className={`${missingFields.includes('Year') ? 'has-error' : ''}`}>Vigencia</label>
                <YearSelector onChange={(e) => { setResponse({ ...response, Year: e }) }} value={response.Year} tittle=" " />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('CodeTurn') ? 'has-error' : ''}`}>Código Turno</label>
                <input type="number" className="form-control" name="CodeTurn" value={response.CodeTurn} onChange={(e) => {
                    const value = e.target.value ? Number(e.target.value) : null;
                    setResponse({ ...response, CodeTurn: value })
                }} />
            </div>
            <div className="col-md-3">
                <BasicButton eventClick={() => { validateData() }} icon="ri-send-plane-line" children={`Enturnar Pago`} useMargin />
            </div>

            <div className="col-md-12">
                <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal}>
                    <div className="row">
                        <div className="col">
                            <DocumentViewer list={documentos} IDDocument={bean.IDDocument} Since={bean.Since} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
}